var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo-container row items-center justify-start"},[(!_vm.logo)?_c('div',{class:['text-subtitle1', { invisible: !!_vm.invisible }]},[_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")]):_vm._e(),(_vm.logo)?_c('img',{class:[{ invisible: !!_vm.invisible }],style:(_vm.logo.style),attrs:{"src":_vm.logo.url}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }